import { ApiClientFactory } from "common/middleware/api.client-factory";

import {
  CreateBuilderCommand,
  PaginatedResultOfBuilderLookUpDto,
} from "./api.services";
import { Logger } from "./logger";

export const getBuilders = async (
  key: string,
  page?: string,
  searchString?: string,
  pageSize?: string,
): Promise<PaginatedResultOfBuilderLookUpDto> => {
  let client = await ApiClientFactory.getBuildersClient();

  const builders = await client.getPage(
    "asc",
    searchString,
    page ? Number(page) : null,
    true,
    pageSize ? Number(pageSize) : 0,
    true
  );

  return builders;
};

export const createBuilder = async (name: string) => {
  Logger.debug("Creating organization", name);

  const client = await ApiClientFactory.getBuildersClient();

  await client.create(CreateBuilderCommand.fromJS({ name }));

  Logger.debug("Successfully created organization", name);
}
